import { useLocation, useRouteMatch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {
  getVenueIdFromPath,
  isVenueDashboardRoute,
} from 'src/components/ollie/ollieVenueRoutes'

/**
 * Resolves the active venue id for Ollie on venue dashboard routes.
 * Uses the URL (/v/:venueId) as source of truth, not admin/supplier context.
 */
function useOllieVenueId() {
  const location = useLocation()
  const venueMatch = useRouteMatch('/v/:venueId')
  const reduxVenueId = useSelector(state => state.venue.venue?._id)
  const onVenueDashboard = isVenueDashboardRoute(location.pathname)
  const routeVenueId =
    venueMatch?.params?.venueId || getVenueIdFromPath(location.pathname)

  if (!onVenueDashboard || !routeVenueId) {
    return {
      onVenueDashboard: false,
      venueId: null,
    }
  }

  return {
    onVenueDashboard: true,
    venueId: String(routeVenueId),
    reduxVenueId: reduxVenueId ? String(reduxVenueId) : null,
    venueSynced: reduxVenueId
      ? String(reduxVenueId) === String(routeVenueId)
      : false,
  }
}

export default useOllieVenueId
